import { Outlet, useLocation, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useState, useEffect } from 'react';
import api from '../api/axios';

export default function Layout() {
  const location = useLocation();
  const { user, selectedBusiness, selectBusiness, logout } = useAuth();
  const [businesses, setBusinesses] = useState([]);
  const [loadingBiz, setLoadingBiz] = useState(true);
  const navigate = useNavigate();
  const [automationOpen, setAutomationOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get('/businesses?_t=' + Date.now()).then(r => {
      const data = Array.isArray(r.data) ? r.data : [];
      const filtered = user?.role === 'admin' ? data : data.filter(b => b.id === user?.business_id);
      setBusinesses(filtered);
      if (filtered.length > 0 && !selectedBusiness) selectBusiness(filtered[0]);
    }).catch(() => {}).finally(() => setLoadingBiz(false));
  }, [user]);

  const automationSubItems = [
    { to: '/automation', label: 'Basic Automations', icon: '🔔' },
    { to: '/automation/custom-reply', label: 'Custom Auto Reply', icon: '↩️' },
    { to: '/automation/workflows', label: 'Workflows', icon: '🔄' },
    { to: '/automation/ai-intent', label: 'AI Intent Matching', icon: '✨' },
    { to: '/automation/ai-agent', label: 'WhatsApp AI Agent', icon: '🤖' },
  ];

  const navItems = [
    { to: '/dashboard', label: 'Dashboard', icon: '📊' },
    { to: '/campaigns', label: 'Campaigns', icon: '📣' },
    { to: '/reports', label: 'Reports', icon: '📊' },
    { to: '/analytics', label: 'Analytics', icon: '📉' },
    { to: '/campaign-reports', label: 'Campaign Reports', icon: '📈' },
    { to: '/templates', label: 'Templates', icon: '📝' },
    { to: '/inbox', label: 'Inbox', icon: '💬' },
    { to: '/leads', label: 'Leads CRM', icon: '🎯' },
    { to: '/integrations', label: 'Integrations', icon: '🔗' },
    { to: '/notifications', label: 'Notifications', icon: '🔔' },
    { to: '/whatsapp-forms', label: 'WA Forms', icon: '📋' },
    { to: '/whatsapp-profile', label: 'WhatsApp Profile', icon: '📱' },
    { to: '/tags', label: 'Tags', icon: '🏷️' },

    { to: '/contacts', label: 'Contact List', icon: '👥' },
    
    { to: '/contact-attributes', label: 'Contact Attributes', icon: '🎯' },
    { to: '/message-logs', label: 'Message Logs', icon: '🗂️' },
    ...(user?.role === 'admin' ? [{ to: '/admin', label: 'Admin Panel', icon: '🛡️' }] : []),
  ];

  if (loadingBiz) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: 18, color: '#6b7280' }}>Loading...</div>
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f0eeff', fontFamily: 'Poppins, sans-serif' }}>
      <aside style={{
        width: 280, background: '#f5f3ff',
        borderRight: '1px solid #ede9fe',
        display: 'flex', flexDirection: 'column', height: '100vh',
        position: 'sticky', top: 0, zIndex: 950,
        boxShadow: '2px 0 12px rgba(124,58,237,0.06)',
      }}>
        {/* Logo */}
        <div style={{ padding: '18px 16px 14px', borderBottom: '1px solid #ede9fe' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
            <div style={{ width: 34, height: 34, borderRadius: 10, background: 'linear-gradient(135deg, #7c3aed, #6d28d9)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 900, color: '#fff', boxShadow: '0 4px 12px rgba(124,58,237,0.3)' }}>V</div>
            <div>
              <div style={{ fontSize: 17, fontWeight: 800, color: '#4c1d95', letterSpacing: 0.3 }}>VBOT</div>
              <div style={{ fontSize: 11, color: '#7c3aed', fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase' }}>WhatsApp CRM</div>
            </div>
          </div>
          {user?.role !== 'admin' && (
            <button onClick={() => navigate('/connect')} style={{
              width: '100%', padding: '9px', borderRadius: 9, border: 'none',
              background: 'linear-gradient(135deg, #7c3aed, #6d28d9)',
              color: '#fff', fontWeight: 700, fontSize: 14, cursor: 'pointer',
              letterSpacing: 0.3, boxShadow: '0 4px 10px rgba(124,58,237,0.25)',
            }}>⚡ Connect WhatsApp</button>
          )}
        </div>

        {/* Nav */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '10px 10px', scrollbarWidth: 'none' }}>
          <div style={{ fontSize: 11, fontWeight: 700, color: '#a78bfa', textTransform: 'uppercase', letterSpacing: 1.5, padding: '6px 8px 4px' }}>Main Menu</div>

          <nav>
            {navItems.map(item => (
              <NavLink key={item.to} to={item.to}
                style={({ isActive }) => ({
                  display: 'flex', alignItems: 'center', gap: 10,
                  padding: '8px 10px', marginBottom: 1, borderRadius: 9,
                  textDecoration: 'none', fontSize: 15,
                  fontWeight: isActive ? 600 : 400,
                  color: isActive ? '#5b21b6' : '#6b7280',
                  background: isActive ? '#ede9fe' : 'transparent',
                  borderLeft: isActive ? '3px solid #7c3aed' : '3px solid transparent',
                  transition: 'all 0.15s',
                })}>
                <span style={{ fontSize: 15, width: 20, textAlign: 'center' }}>{item.icon}</span>
                <span>{item.label}</span>
              </NavLink>
            ))}
          </nav>

          {/* Settings */}
          <div style={{ fontSize: 11, fontWeight: 700, color: '#a78bfa', textTransform: 'uppercase', letterSpacing: 1.5, padding: '10px 8px 4px' }}>Settings</div>
          <nav>
            <NavLink to="/agents" style={({ isActive }) => ({ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', marginBottom: 1, borderRadius: 9, textDecoration: 'none', fontSize: 15, fontWeight: isActive ? 600 : 400, color: isActive ? '#5b21b6' : '#6b7280', background: isActive ? '#ede9fe' : 'transparent', borderLeft: isActive ? '3px solid #7c3aed' : '3px solid transparent', transition: 'all 0.15s' })}>
              <span style={{ fontSize: 15, width: 20, textAlign: 'center' }}>👤</span>
              <span>Agents</span>
            </NavLink>
          </nav>
          {/* Automation */}
          <div style={{ fontSize: 11, fontWeight: 700, color: '#a78bfa', textTransform: 'uppercase', letterSpacing: 1.5, padding: '10px 8px 4px' }}>Automation</div>
          <div>
            <div onClick={() => setAutomationOpen(v => !v)} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '8px 10px', marginBottom: 1, borderRadius: 9, cursor: 'pointer',
              fontSize: 15, fontWeight: 400, color: '#6b7280',
              borderLeft: '3px solid transparent',
            }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span style={{ fontSize: 15, width: 20, textAlign: 'center' }}>⚙️</span>
                <span>Automation</span>
              </span>
              <span style={{ fontSize: 11, color: '#a78bfa' }}>{automationOpen ? '▲' : '▼'}</span>
            </div>
            {automationOpen && (
              <div style={{ paddingLeft: 10, borderLeft: '2px solid #ddd6fe', marginLeft: 14, marginBottom: 4 }}>
                {automationSubItems.map(item => (
                  <NavLink key={item.to} to={item.to}
                    style={({ isActive }) => ({
                      display: 'flex', alignItems: 'center', gap: 8,
                      padding: '7px 10px', marginBottom: 1, borderRadius: 7,
                      textDecoration: 'none', fontSize: 14,
                      fontWeight: isActive ? 600 : 400,
                      color: isActive ? '#7c3aed' : '#9ca3af',
                      background: isActive ? '#ede9fe' : 'transparent',
                    })}>
                    <span style={{ fontSize: 13 }}>{item.icon}</span>
                    <span>{item.label}</span>
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Bottom */}
        <div style={{ padding: '12px 12px', borderTop: '1px solid #ede9fe' }}>
          {user?.role === 'admin' && (
            <>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#a78bfa', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 6 }}>Select Business</div>
              <select value={selectedBusiness?.id || ''}
                onChange={e => { const b = businesses.find(x => x.id == e.target.value); if (b) selectBusiness(b); }}
                style={{ width: '100%', padding: '7px 10px', border: '1px solid #ddd6fe', borderRadius: 8, fontSize: 14, marginBottom: 10, background: '#fff', color: '#4c1d95', outline: 'none' }}>
                <option value="">-- Choose --</option>
                {businesses.map(b => (
                  <option key={b.id} value={b.id}>{b.name || `Business ${b.waba_id}`}</option>
                ))}
              </select>
            </>
          )}

          {selectedBusiness && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8, padding: '6px 10px', borderRadius: 8, background: '#ede9fe' }}>
              <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#7c3aed' }} />
              <span style={{ fontSize: 11, color: '#5b21b6', fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {selectedBusiness.name || `Business ${selectedBusiness.id}`}
              </span>
            </div>
          )}

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 8px', borderRadius: 8, background: '#f5f3ff', border: '1px solid #ede9fe' }}>
            <div>
              <div style={{ fontSize: 11, color: '#4c1d95', fontWeight: 600 }}>{user?.name || user?.email}</div>
              <div style={{ fontSize: 10, color: '#a78bfa', textTransform: 'uppercase', letterSpacing: 0.5 }}>{user?.role}</div>
            </div>
            <button onClick={() => { logout(); navigate('/login'); }}
              style={{ background: '#fef2f2', border: '1px solid #fecaca', color: '#ef4444', cursor: 'pointer', fontSize: 11, fontWeight: 600, padding: '5px 10px', borderRadius: 6 }}>
              Logout
            </button>
          </div>
        </div>
      </aside>

      <main style={{ flex: 1, padding: location.pathname === '/inbox' ? '0' : '24px 28px', overflow: location.pathname === '/inbox' ? 'hidden' : 'auto', display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </main>
    </div>
  );
}
